import { render, staticRenderFns } from "./ChatFlow.vue?vue&type=template&id=297ae38d&scoped=true&"
import script from "./ChatFlow.vue?vue&type=script&lang=js&"
export * from "./ChatFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ae38d",
  null
  
)

export default component.exports